export default (price, type, useDefaultCurrency) => {
  var currency = {};
  if (localStorage.getItem("tenantCurrency") === null) {
    currency = {
      code: "USD",
      name: "US Dollar",
      symbol: "$",
    };
  } else {
    currency = JSON.parse(localStorage.getItem("tenantCurrency"));
  }
  let formattedPrice = "";
  if (type === false) {
    if (currency.code === "KWD") {
      formattedPrice = "KD";
    } else {
      if (currency.symbol) {
        formattedPrice = currency.symbol;
      } else {
        formattedPrice = currency.code;
      }
    }
    // formattedPrice = '$';
  } else {
    if (useDefaultCurrency) {
      const tempPrice = Number(price).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      formattedPrice = "$ " + tempPrice;
    } else if (currency.code === "KWD") {
      // var tempPrice = (+price).toFixed(2);
      // formattedPrice = "KD " + tempPrice;
      const tempPrice = Number(price).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      formattedPrice = "KD " + tempPrice;
    } else {
      formattedPrice = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency.code,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }).format(price);
    }
  }
  return formattedPrice;
};
